exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box_3b0be9f{display:inline-block}.flex_4714acd{display:flex;width:320px;justify-content:space-between;align-items:center}.inputNumberW_3819ae8{width:80px!important}.inputW_16dafc9{width:400px!important}.tableW_af23429{width:600px;padding-left:60px;margin:10px 0 20px}.textarea_66283ca{width:400px!important;height:200px}.textarea_66283ca .k-textarea{height:200px!important;resize:none}", ""]);

// exports
exports.locals = {
	"box": "box_3b0be9f",
	"flex": "flex_4714acd",
	"inputNumberW": "inputNumberW_3819ae8",
	"inputW": "inputW_16dafc9",
	"tableW": "tableW_af23429",
	"textarea": "textarea_66283ca"
};